import React from 'react'
import styled from 'styled-components'

import { CTAKey, getCTAByKey } from '@/components/common/cta'

import { NavMenuLinkProps } from './nav-menu-link'
import { NavMenuLinkList } from './nav-menu-link-list'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: rgb(18, 18, 18);
  opacity: 0.95;
  overflow: hidden;
  align-items: center;
  justify-content: center;
`

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  height: 60vh;
`

const Home = styled.span`
  color: white;
  font-weight: bold;
  font-size: 25px;
`

type ModalMenuProps = {
  titles: NavMenuLinkProps[]
  ctaKey: CTAKey
}

const ModalNavMenu: React.FC<ModalMenuProps> = (props) => {
  const { titles, ctaKey } = props
  const CTA = getCTAByKey(ctaKey)

  return (
    <Container>
      <Menu>
        <Home>Home</Home>
        <NavMenuLinkList titles={titles} />
        {!!CTA.MobilePrimaryHeaderCTA && <CTA.MobilePrimaryHeaderCTA />}
      </Menu>
    </Container>
  )
}

export default ModalNavMenu
